function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGetCouponFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M10.994 6.984H4a2 2 0 00-2 2v8a2 2 0 110 4v7a2 2 0 002 2h24a2 2 0 002-2v-7a2 2 0 010-4v-8a2 2 0 00-2-2h-6.995v2H28v6.537a3.998 3.998 0 000 6.927v5.536H4v-5.537a3.999 3.999 0 000-6.926V8.984h6.994v-2z",
    fill: props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.01 14.435l-1.414-1.414L17 16.617V2.031h-2v14.586l-3.596-3.596-1.414 1.414 6.01 6.01 6.009-6.01z",
    fill: props.color
  }));
}

export default SvgIconGetCouponFilled;